module.exports = __webpack_public_path__ + "resources/img/career-welfareImg7.a800ea5f.jpg";